var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightHalfCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 409,
    height: 211,
    viewBox: "0 0 409 211",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_12066_204517",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 409,
    height: 211
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 16C0 7.16345 7.16344 0 16 0H393C401.837 0 409 7.16344 409 16V210.375H16C7.16343 210.375 0 203.212 0 194.375V16Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_12066_204517)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 267.5,
    cy: 131.5,
    rx: 179.5,
    ry: 185.5,
    fill: "#F8A63F"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightHalfCircle);
export default __webpack_public_path__ + "static/media/right-half-circle.cb3d7ee14e0c102a4a0fd7afe6dc1ede.svg";
export { ForwardRef as ReactComponent };